import './app.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Card } from 'reactstrap';
import { HashRouter as Router } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import { IRootState } from 'app/shared/reducers';
import { getSession } from 'app/shared/reducers/authentication';
import { getProfile } from 'app/shared/reducers/application-profile';
import { setLocale } from 'app/shared/reducers/locale';
import Header from 'app/shared/layout/header/header';
import Footer from 'app/shared/layout/footer/footer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import ErrorBoundary from 'app/shared/error/error-boundary';
import { AUTHORITIES } from 'app/config/constants';
import AppRoutes from 'app/routes';
import GAListener from 'app/shared/util/ga-util';
import * as moment from 'moment';

export interface IAppProps extends StateProps, DispatchProps {}

export class App extends React.Component<IAppProps> {
  componentDidMount() {
    moment.locale('zh-hk'); // TODO: GIL: hardcode set locale here for initial load
    // this.props.getSession();
    // this.props.getProfile();
    this.deleteCookie('noq-script-token-patotix-demo');
    this.deleteCookie('noq-script-token-patotix');
  }

  deleteCookie = name => {
    if (this.getCookie(name)) {
      document.cookie = name + '= ;expires=Thu, 01 Jan 1970 00:00:01 GMT';
    }
  };

  getCookie = name => document.cookie.split(';').some(c => c.trim().startsWith(name + '='));

  render() {
    const paddingTop = '0px';
    return (
      <Router>
        <GAListener>
          <div className="app-container" style={{ paddingTop }}>
            <ToastContainer position={toast.POSITION.TOP_LEFT} className="toastify-container" toastClassName="toastify-toast" />
            <ErrorBoundary>
              <Header
                isAuthenticated={this.props.isAuthenticated}
                isAdmin={this.props.isAdmin}
                currentLocale={this.props.currentLocale}
                onLocaleChange={this.props.setLocale}
                ribbonEnv={this.props.ribbonEnv}
                isInProduction={this.props.isInProduction}
                isSwaggerEnabled={this.props.isSwaggerEnabled}
              />
            </ErrorBoundary>
            <div className="container-fluid view-container" id="app-view-container">
              <Card className="jh-card">
                <ErrorBoundary>
                  <AppRoutes />
                </ErrorBoundary>
              </Card>
              <Footer />
            </div>
          </div>
        </GAListener>
      </Router>
    );
  }
}

const mapStateToProps = ({ authentication, applicationProfile, locale }: IRootState) => ({
  currentLocale: locale.currentLocale,
  isAuthenticated: authentication.isAuthenticated,
  isAdmin: hasAnyAuthority(authentication.account.authorities, [AUTHORITIES.ADMIN]),
  ribbonEnv: applicationProfile.ribbonEnv,
  isInProduction: applicationProfile.inProduction,
  isSwaggerEnabled: applicationProfile.isSwaggerEnabled
});

const mapDispatchToProps = { setLocale, getSession, getProfile };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(App);
